// extracted by mini-css-extract-plugin
export default {"searchWrapper":"SearchInput_searchWrapper__fMfXY","search":"SearchInput_search__wBBqr","clearBtn":"SearchInput_clearBtn__s72Pj"};